import { render } from "./AddTransportIncident.vue?vue&type=template&id=4e3b7efe"
import script from "./AddTransportIncident.vue?vue&type=script&lang=js"
export * from "./AddTransportIncident.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__